module.exports = __webpack_public_path__ + "Server-Default-OfflineDrop.2677b561565412ebe38e3b5fa8f936db.hashedasset.svg";